import {request, serviceUrl} from "@/utils/request";

//根据code获取业务数据字典
export function getMasterDataByCode(code) {
  return request({
    url: serviceUrl.extensionService + '/ext/master-data/list',
    params: {
      code
    }
  })
}

//根据父级code获取业务数据字典列表
export function getListByParentCode(parentCode) {
  return request({
    url: serviceUrl.extensionService + '/ext/master-data/getListByParentCode',
    params: {
      parentCode
    }
  })
}

// 获取机房安全运行
export function getRoomSafety() {
  return request({
    url: serviceUrl.extensionService + '/server/usage/statistic',
  })
}